import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { LANGUAGES } from '../scope';

/**
 * This report's own scope controls, in the shared grid beside the property: the one URL to inspect
 * and the language Google's issue messages come back in.
 *
 * The URL sits in the scope bar rather than in a form of its own so the page keeps a single place
 * where its request is chosen and a single button that sends it. Typing never inspects anything;
 * Enter in the field does what the Inspect button does, because that is what a lone URL field
 * invites, and it is held to the same checks the button is.
 */
function ExtraControls({ t, draft, onChange, onSubmit }) {
    const languageOptions = LANGUAGES.map((value) => ({ value, label: value }));

    return (
        <>
            <div className="gsc-tool-field gsc-tool-field-wide">
                <label htmlFor="url-inspection-url">{t('tools.url_inspection.controls.url')}</label>
                <input
                    id="url-inspection-url"
                    type="url"
                    className="form-control"
                    value={draft.inspectionUrl}
                    placeholder={t('tools.url_inspection.controls.url_placeholder')}
                    onChange={(event) => onChange({ inspectionUrl: event.target.value })}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') onSubmit();
                    }}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.url_inspection.controls.url_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.url_inspection.controls.language')}</label>
                <ReactSelect
                    options={languageOptions}
                    value={languageOptions.find((item) => item.value === draft.languageCode)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ languageCode: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.url_inspection.controls.language_note')}
                </span>
            </div>
        </>
    );
}

export default withTranslation()(ExtraControls);
